module.exports = __webpack_public_path__ + "static/media/md-filing.e019d3c2.svg";